// src/App.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import TileSelection from "./components/tileselection";
import Configurator from "./components/configurator";
import Header from "./components/header";
import Footer from "./components/footer";
import "./App.css";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<TileSelection />} />
        <Route path="/pre-order/:id" element={<Configurator />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
